<template>
    <v-snackbar v-model="alerta" :color="color" bottom rounded="pill" :content-class="snackbarClass">
      {{ textAlert }}
    </v-snackbar>
</template>
<script>
  export default {
    props: {
      alert: Boolean,
      color: String,
      textAlert: String
    },
    computed: {
      alerta: {
        get() {
          return this.alert;
        },
        set(newValue) {
          return newValue;
        }
      },
      snackbarClass() {
        return 'text-center';
      }
    }
  };
  </script>
  
  <style>
  </style>
  